import styled from 'styled-components';

export const IncomeVerificationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 11px -1px rgb(229, 229, 229);
  margin: 15px 0px;
  padding: 1em;
  border-radius: 1em;
  row-gap: 20px;
  .mainContent {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    justify-content: center;
  }
  .center {
    display: flex;
    justify-content: center;
  }
  .bankOptions {
    display: flex;
    flex-direction: column;
    background-color: #FFFEFC;
    border: 1px solid #AE8E68;
    border-radius: 10px;
    padding: 0 10px;
  }
  .line-one {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  @media only screen and (max-width: 768px) {
    border-radius: 0;
    padding: 0;
    box-shadow: none;
  }
  .income-page-note {
    margin: 0;
    text-align: center;
    color: #717171;
  }
`;
